export { default } from './toImmutableMap'
